import { appRoutes } from "@/app/router";
import { PageStore } from "@/store";
import { CollectionsListPageStore } from "@/store/pages/CollectionsListPageStore/CollectionsListPageStore";
import { CollectionsViewPageStore } from "@/store/pages/CollectionsViewPageStore/CollectionsViewPageStore";
import { NotesListPageStore } from "@/store/pages/NotesListPageStore";
import { ListStateObservable } from "@/store/pages/ListStateObservable";
import { Tab } from "@/store/navigation/types";
import { To, matchPath } from "react-router";

const isNotesListPath = (pathname: string) =>
  pathname === appRoutes.notesList({}).path ||
  !!matchPath(
    appRoutes.importBatchNotes({ params: { importBatchId: ":importBatchId" } }).path,
    pathname
  );

const isCollectionsListPath = (pathname: string) =>
  pathname === appRoutes.collections({}).path ||
  !!matchPath(
    appRoutes.importBatchCollections({ params: { importBatchId: ":importBatchId" } }).path,
    pathname
  );

const isCollectionsViewPath = (pathname: string) =>
  !!matchPath(
    appRoutes.collectionsView({ params: { collectionId: ":collectionId" }, starPattern: true })
      .path,
    pathname
  ) || !!matchPath("/c/:collectionId/*", pathname);

const getPathname = (path: To): string | undefined => {
  if (typeof path === "string") {
    return path;
  }

  return path.pathname;
};

export const resolveChatSelectionAttachListState = ({
  pageStore,
  activeTab,
  activeTabPath,
}: {
  pageStore: PageStore;
  activeTab: Tab | null;
  activeTabPath: To;
}): ListStateObservable | null => {
  const pathname = getPathname(activeTabPath);
  if (!pathname) {
    return null;
  }

  if (isNotesListPath(pathname)) {
    const notesListPageStore = pageStore.getPageStore(
      activeTab,
      activeTabPath,
      "notesListPage"
    ) as NotesListPageStore | null;
    return notesListPageStore?.listState ?? null;
  }

  if (isCollectionsListPath(pathname)) {
    const collectionsListPageStore = pageStore.getPageStore(
      activeTab,
      activeTabPath,
      "collectionsListPage"
    ) as CollectionsListPageStore | null;
    return collectionsListPageStore?.listState ?? null;
  }

  if (isCollectionsViewPath(pathname)) {
    const collectionsViewPageStore = pageStore.getPageStore(
      activeTab,
      activeTabPath,
      "collectionsViewPage"
    ) as CollectionsViewPageStore | null;
    return collectionsViewPageStore?.listState ?? null;
  }

  return null;
};
